





























































import Vue from "vue";
import { formatSize } from "@/utils/util";
import { parseTime } from "@/utils/filters";
import { IFeedItem } from "@/types/post";

export default Vue.extend({
  name: "feed-info",
  filters: {
    displayPublisher(info: IFeedItem) {
      if (info.user_info) {
        return info.user_info.nickname || info.user_info.user_id;
      }
      return "-";
    },
    parseTime(time: string) {
      return parseTime(time, "{y}-{m}-{d}");
    },
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {},
  async mounted() {},
  methods: {
    formatSize,
  },
});
